export default __webpack_public_path__ + "static/media/krilne.3821d58c.png";